// extracted by mini-css-extract-plugin
export var colorSquare = "_p0-0";
export var danger = "_p0-5";
export var lightPink = "_p0-8";
export var neutralBlue = "_p0-7";
export var neutralYellow = "_p0-6";
export var normal = "_p0-1";
export var primary = "_p0-2";
export var primaryLight = "_p0-3";
export var solidBlack = "_p0-g";
export var solidGreen = "_p0-b";
export var solidLightBlue = "_p0-d";
export var solidNavy = "_p0-c";
export var solidOrange = "_p0-f";
export var solidPink = "_p0-e";
export var solidRed = "_p0-9";
export var solidYellow = "_p0-a";
export var success = "_p0-4";